/**
 * Order for the Existing Positions panel: the funder that was paid most
 * recently sits at the top, the one paid longest ago at the bottom.
 *
 * The backend already emits funder groups in this order, but analysis runs
 * persisted before it did are still rendered from their stored JSON, so the
 * dashboard applies the same rule client-side. Groups without a last payment
 * date keep their relative server order and sink below the dated ones.
 */

export interface RecencyOrderable {
  last_payment_date?: string | null;
}

function recencyOrdinal(iso: string | null | undefined): number | null {
  if (!iso) return null;
  const parsed = Date.parse(iso.slice(0, 10));
  return Number.isNaN(parsed) ? null : parsed;
}

export function sortByLastPaymentDesc<T extends RecencyOrderable>(groups: readonly T[]): T[] {
  return groups
    .map((group, index) => ({ group, index, paid: recencyOrdinal(group.last_payment_date) }))
    .sort((a, b) => {
      if (a.paid === null && b.paid === null) return a.index - b.index;
      if (a.paid === null) return 1;
      if (b.paid === null) return -1;
      if (a.paid !== b.paid) return b.paid - a.paid;
      return a.index - b.index;
    })
    .map(({ group }) => group);
}
